module.exports = __webpack_public_path__ + "img/eye-on.75707fa5.svg";